// Footer.js
const Footer = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t z-40 select-none" 
         style={{
           WebkitOverflowScrolling: 'none',
           overscrollBehavior: 'none',
           touchAction: 'none',
           userSelect: 'none'
         }}>
      <div className="container mx-auto px-4 py-3">
        <div className="flex justify-center items-center space-x-2">
          <span className="text-gray-600 text-sm">Powered by</span>
          <a 
            href="https://github.com/brianRamesar" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center space-x-1 text-sm font-semibold bg-gradient-to-r from-blue-500 to-green-500 bg-clip-text text-transparent hover:opacity-80 transition-opacity"
            style={{ touchAction: 'auto' }}
          >
            SoftShoreTech
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;